import { NgModule } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { RoutesRoutingModule } from "./routes-routing.module";

import {
  DashboardComponent
 } from "./components/dashboard/dashboard.component";
import {
  WelcomeComponent
} from "./components/welcome/welcome.component";
import { DialogAddUserComponent,
         DialogEditUserComponent,
         DialogRemoveUserComponent,
         UserAdministrationComponent } from "@shared/components/user-administration/user-administration.component";

const COMPONENTS = [
  DashboardComponent,
  UserAdministrationComponent,
  DialogAddUserComponent,
  DialogEditUserComponent,
  DialogRemoveUserComponent,
  WelcomeComponent
];
const COMPONENTS_DYNAMIC = [];

@NgModule({
    imports: [SharedModule, RoutesRoutingModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC]
})
export class RoutesModule {}
